angular.module('mw-alert').constant('mwAlertConfig', {
	parent_selector: 'body',
	timeout:         3000,
	close_auto:      true,
	templateUrl:     'mw-alert.html'
});